import React from "react";
import { Column } from "primereact/column";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import LaddaButton from "../buttons/laddaButton";
import "./styles.css";
import { Link, useNavigate } from "react-router-dom";
import { icons } from "../../constants";
import {
  getCurrentMonthYear,
  getCurrentMonthYearWithDate,
  getDateObj
} from "../../utils/dateUtils";
import { useDispatch } from "react-redux";
import { setBreadCrumData } from "../../redux/slices/breadCrumbSlice";
import { parse, getYear, getMonth } from "date-fns";
import { CircularProgress, useMediaQuery } from "@mui/material";
import FileUpload from "../uploadFiles";

// ---------------------------- FUNTIONS ----------------------------

const getButtons = (btnsArray, data, onClickFunction, label, rowIndex) => {
  if (!Array.isArray(btnsArray)) {
    throw new Error("El primer parámetro debe ser un array.");
  }
  const dataWithRowIndex = {
    ...data,
    simpleTableRowOrder1Based: rowIndex + 1
  };

  return btnsArray.map((option) => {
    switch (option.type) {
      case "icon":
        return iconBtnTemplate(dataWithRowIndex, option);
      case "iconEditableHide":
        return iconHideEditableBtnTemplate(dataWithRowIndex, option);
      case "redirectData":
        return redirecDataBtnTemplate(dataWithRowIndex, option);
      case "iconSwitch":
        return iconSwitchBtnTemplate(dataWithRowIndex, option);
      case "button":
        return tableBtnTemplate(dataWithRowIndex, label, onClickFunction);
      case "dateHideButton":
        return dateHideBtnTemplate(dataWithRowIndex, option);
      case "uploadBtn":
        return uploadBtnTemplate(dataWithRowIndex, option);
      case "tooltip":
        return tooltipTemplate(dataWithRowIndex, option);
      default:
        console.warn(`Opción no reconocida: ${option}`);
        return null;
    }
  });
};

// ---------------------------- COLUMNS TEMPLATES ----------------------------

export const defaultColumn = (item, fulltext) => {
  const truncateText = (text, maxLength = 145) => {
    if (!text) return "";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  return (
    <Column
      style={{ width: item?.columnWidth ? item.columnWidth : "auto" }}
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className="table-column-container">
            <p className="table-default-column">
              {fulltext === true
                ? rowData[item.field]
                : truncateText(rowData[item.field])}
            </p>
          </div>
        );
      }}
    />
  );
};

export const columnRight = (item) => {
  const truncateText = (text, maxLength = 100) => {
    if (text === null || text === undefined || text === "") return "";
    const str = String(text);
    return str.length > maxLength
      ? `${str.substring(0, maxLength)}...`
      : str;
  };
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className="table-column-container">
            <p className="table-default-column" style={{ textAlign: "right" }}>
              {truncateText(rowData[item.field])}
            </p>
          </div>
        );
      }}
    />
  );
};

export const hideColumn = (item) => {
  return null;
};

export const urlColumn = (item) => {
  const truncateText = (text, maxLength = 100) => {
    if (!text) return "";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className="table-column-container">
            <a
              href={rowData[item.field]}
              className="url-column"
              target="_blank"
            >
              {truncateText(rowData[item.field])}
            </a>
          </div>
        );
      }}
    />
  );
};

export const titlesColumn = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      style={{ width: item?.columnWidth ? item.columnWidth : "auto" }}
      body={(rowData) => {
        return (
          <div className="table-buttons-container">
            <p className="table-titles-column">{rowData[item.field]}</p>
          </div>
        );
      }}
    />
  );
};

export const pillsColumn = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className={`pill-buttons-container HContainer j-center`}>
            <div
              className={`pill-table-column ${
                rowData[item.field] === "Nivel Alto" ||
                rowData[item.field] === "Alto"
                  ? "level-redPill level-pill-font"
                  : rowData[item.field] === "Nivel Medio" ||
                    rowData[item.field] === "Medio"
                  ? "level-yellowPill level-pill-font"
                  : rowData[item.field] === "Nivel Bajo" ||
                    rowData[item.field] === "Bajo"
                  ? "level-greenPill level-pill-font"
                  : rowData[item.field] === "Superior"
                  ? "level-redPill level-pill-font"
                  : ""
              }`}
            >
              <p className="pill-table-column-text">{rowData[item.field]}</p>
            </div>
          </div>
        );
      }}
    />
  );
};

export const actionButtonsColumn = (
  item,
  buttons,
  onClickftn,
  label,
  frozen
) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      frozen={frozen}
      alignFrozen="right"
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""} ${
        frozen ? "table-header-blueBlack" : ""
      }`}
      body={(rowData, { rowIndex }) => {
        return (
          <div className={`table-buttons-container no-print`}>
            {getButtons(buttons, rowData, onClickftn, label, rowIndex)}
          </div>
        );
      }}
    />
  );
};

export const editButtonsColumn = (item, buttons, onClickftn, label, data) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        {
          return rowData.isEditable !== true ? (
            <></>
          ) : (
            <div className="table-buttons-container">
              {getButtons(buttons, rowData, onClickftn, label)}
            </div>
          );
        }
      }}
    />
  );
};

export const actionSelfApraisalButtonsColumn = (
  item,
  buttons,
  onClickftn,
  label,
  hideBtn
) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return rowData.completed && rowData.completed !== 0 ? (
          <></>
        ) : hideBtn ? (
          <div className="table-buttons-container">
            {getButtons(buttons, rowData, onClickftn, label)}
          </div>
        ) : null;
      }}
    />
  );
};

export const tooltipColumn = (item, tooltipFragment) => {
  const maxLength =
    item.truncateLength != null && item.truncateLength !== ""
      ? Number(item.truncateLength)
      : 200;
  const truncateText = (text) => {
    if (!text) return "";
    const cap = Number.isFinite(maxLength) && maxLength > 0 ? maxLength : 200;
    return text.length > cap ? `${text.substring(0, cap)}...` : text;
  };

  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      style={{
        width: item?.columnWidth ? item.columnWidth : "auto",
        maxWidth: item?.columnMaxWidth ? item.columnMaxWidth : undefined
      }}
      body={(rowData) => {
        return (
          <StyledTooltip
            title={
              tooltipFragment &&
              tooltipFragment(
                rowData[item.tooltipField]
                  ? rowData[item.tooltipField]
                  : rowData[item.field]
              )
            }
            followCursor
          >
            <div
              style={{
                maxWidth: item?.columnMaxWidth || item?.columnWidth || "100%",
                overflow: "hidden"
              }}
            >
              <p
                className="table-default-column"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  margin: 0
                }}
              >
                {truncateText(rowData[item.field])}
              </p>
            </div>
          </StyledTooltip>
        );
      }}
    />
  );
};

export const redirectionColumn = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className="pill-buttons-container">
            <Link
              className="column-link"
              to={{
                pathname: item.url,
                state: rowData
              }}
            >
              {rowData[item.field]}
            </Link>
          </div>
        );
      }}
    />
  );
};

export const percentageBtnColumn = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className="pill-buttons-container j-center align-center">
            <p
              className={
                rowData[item.field] < 80
                  ? "updown-text-red"
                  : "updown-text-green"
              }
            >
              {rowData[item.field]} %
            </p>

            {rowData[item.field] < 80 ? (
              <div
                style={{ marginLeft: "5px" }}
                className="eye-btn"
                onClick={() => console.log(rowData)}
              >
                <img className="btn-icon" src={icons.comments_icon} alt="eye" />
              </div>
            ) : (
              ""
            )}
          </div>
        );
      }}
    />
  );
};

export const upDownNumberColumn = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        return (
          <div className="pill-buttons-container j-center">
            <p
              className={
                rowData[item.field] < 200000000
                  ? "updown-text-red"
                  : "updown-text-green"
              }
            >
              {rowData[item.field]}
            </p>
            {rowData[item.field] < 200000000 ? (
              <img
                className="btn-icon"
                src={icons.arrow_drop_down}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
            ) : (
              <img
                className="btn-icon"
                src={icons.arrow_drop_up}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
            )}
          </div>
        );
      }}
    />
  );
};

export const expanderColumn = (item) => {
  return (
    <Column
      key={item.field}
      expander
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
    />
  );
};

export const checkBoxColumn = (item) => {
  return (
    <Column
      headerStyle={{ width: "3rem" }}
      selectionMode="single"
      key={item.field}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
    />
  );
};

const iconBtnTemplate = (rowData, option) => {
  const shouldHide = option?.hideCondition?.(rowData);
  if (shouldHide) return null;

  const isLoading = option?.isLoading?.(rowData);

  const iconStyle = option.iconSize ? { "--icon-size": option.iconSize } : {};

  return (
    <div
      className={`eye-btn ${isLoading ? "disabled" : ""}`}
      onClick={() => {
        if (!isLoading && option.onClick) option.onClick(rowData);
      }}
      style={{
        pointerEvents: isLoading ? "none" : "auto",
        opacity: isLoading ? 0.6 : 1
      }}
    >
      {isLoading ? (
        <CircularProgress size={20} thickness={5} />
      ) : (
        <img
          className="btn-icon-table"
          src={option.icon}
          alt="icon"
          style={iconStyle}
        />
      )}
    </div>
  );
};

const iconHideEditableBtnTemplate = (rowData, option) => {
  if (!option.icon) {
    console.warn("No icon provided for the button");
  }

  return (
    rowData.editable && (
      <div
        className="eye-btn"
        onClick={() =>
          option.onClick ? option.onClick(rowData) : console.log(rowData)
        }
      >
        <img className="btn-icon-table" src={option.icon} alt="icon" />
      </div>
    )
  );
};

const RedirecDataBtn = ({ rowData, option }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    if (
      option.url == "/riskAndOpportunityManagement/riskAdminGestion" ||
      option.url == "/riskAndOpportunityManagement/opportunityAdminGestion"
    ) {
      dispatch(
        setBreadCrumData({ rowData: { ...rowData, ...option.extraData } })
      );
    }
    navigate(option.url, {
      state: { rowData: { ...rowData, ...option.extraData } }
    });
  };

  return (
    <div className="eye-btn" onClick={handleClick}>
      {option.icon ? (
        <img className="btn-icon-table" src={option.icon} alt="icon" />
      ) : (
        console.warn("No icon provided for the button")
      )}
    </div>
  );
};

const redirecDataBtnTemplate = (rowData, option) => {
  return <RedirecDataBtn rowData={rowData} option={option} />;
};

const iconSwitchBtnTemplate = (rowData, option) => {
  if (!option.icon) {
    console.warn("No icon provided for the button");
  }
  var isEditable = getCurrentMonthYearWithDate(rowData.creation_date);
  return (
    <div
      className="eye-btn"
      onClick={() =>
        option.onClick ? option.onClick(rowData) : console.log(rowData)
      }
    >
      {isEditable ? (
        <img className="btn-icon-table" src={option.icon} alt="icon" />
      ) : (
        <img className="btn-icon-table" src={option.icon2} alt="icon" />
      )}
    </div>
  );
};

const dateHideBtnTemplate = (rowData, option) => {
  if (!option.icon) {
    console.warn("No icon provided for the button");
  }

  const date = parse(rowData.date, "dd/MM/yyyy", new Date());
  var isEditable = getCurrentMonthYear(getYear(date), getMonth(date) + 1);

  if (isEditable) {
    return (
      <div
        className="eye-btn"
        onClick={() =>
          option.onClick ? option.onClick(rowData) : console.log(rowData)
        }
      >
        <img className="btn-icon-table" src={option.icon} alt="icon" />
      </div>
    );
  } else {
    return;
  }
};

export const counterColumn = (item) => {
  return (
    <Column
      key={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData, { rowIndex }) => {
        return (
          <div className="table-column-container">
            <p className="table-default-column">{rowIndex + 1}</p>
          </div>
        );
      }}
    />
  );
};

const tableBtnTemplate = (rowData, label, onClickftn) => {
  return (
    <LaddaButton
      variant={"contained"}
      backgroundColor={"#6A6AD8"}
      color={"#FFFF"}
      margin={"7px 5px 0 5px"}
      onClick={() => (onClickftn ? onClickftn(rowData) : console.log(rowData))}
      width={"max-content"}
      fontSize={"12px"}
    >
      <p>{label}</p>
    </LaddaButton>
  );
};

export const moneyColumn = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      bodyClassName="table-body-styled"
      body={(rowData) => {
        const rawValue = rowData[item.field];
        const numericValue = Number(rawValue);

        const formattedValue = !isNaN(numericValue)
          ? new Intl.NumberFormat("es-CO", {
              style: "currency",
              currency: "COP",
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
              useGrouping: true
            }).format(numericValue)
          : "-";

        return <p className="table-default-column">{formattedValue}</p>;
      }}
    />
  );
};

const uploadBtnTemplate = (rowData, option) => {
  const { onClick, icon } = option;

  const shouldHide = option?.hideCondition?.(rowData);

  if (shouldHide) return null;

  return (
    <FileUpload
      id={`upload-${rowData.id}`}
      onFinish={option?.onFinish}
      icon={icon}
      rowData={rowData}
      setResult={({ fileName, originalName, path, rowData }) => {
        if (onClick) {
          onClick({ fileName, originalName, path, rowData });
        }
      }}
    />
  );
};

const tooltipTemplate = (rowData, option) => {
  const { onClick, icon, tooltipContent,   } = option;

  return (
    <StyledTooltip title={tooltipContent} placement="top" onClick={onClick}>
      <div className="HContainer pointer">
        <img
          src={icon ? icon : icons.infoExclamationWhite}
          alt="info"
          className="btn-icon-table"
        />
      </div>
    </StyledTooltip>
  );
};

export const formatCurrentDate = () => {
  const { day, month, year } = getDateObj();
  const formattedDay = String(day).padStart(2, "0");
  const formattedMonth = String(month).padStart(2, "0");
  return `${year}-${formattedMonth}-${formattedDay}`;
};

export const columnList = (item) => {
  return (
    <Column
      key={item.field}
      field={item.field}
      header={item.header}
      sortable={item.ordenable}
      headerClassName={`table-header-styled ${
        item.index === 0 ? "table-header-rounded-left" : ""
      } ${item.lastItem === true ? "table-header-rounded-right" : ""}`}
      body={(rowData) => {
        const list = rowData[item.field];
        const propertyToShow = item.property || "name";

        if (!list || !Array.isArray(list)) {
          return <div className="table-column-container"></div>;
        }

        const fullTextList = list
          .map((obj) => obj[propertyToShow] || "")
          .join(", ");

        return (
          <StyledTooltip
            title={
              <>
                <div>
                  <p className="toolkit-title">{item.header}:</p>
                  {list.map((obj, index) => {
                    const value = obj[propertyToShow] || "";

                    return (
                      <div
                        key={index}
                        className="list-column-item"
                        style={{
                          lineHeight: "20px",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        <span className="table-default-column">- {value}</span>
                      </div>
                    );
                  })}
                </div>
              </>
            }
            followCursor
          >
            <div
              className="table-column-container p-overlay-trigger"
              data-pr-tooltip={fullTextList}
              data-pr-position="top"
              data-pr-track-mouse="true"
              style={{ maxWidth: "100%" }}
            >
              <div
                className="list-column-container"
                style={{ display: "flex", flexDirection: "column", gap: "2px" }}
              >
                {list.map((obj, index) => {
                  const value = obj[propertyToShow] || "";
                  const displayValue =
                    value.length > 35 ? value.slice(0, 35) + "..." : value;

                  return (
                    <div
                      key={index}
                      className="list-column-item"
                      style={{
                        height: "20px",
                        lineHeight: "20px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                      }}
                    >
                      <span className="table-default-column">
                        {displayValue}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </StyledTooltip>
        );
      }}
    />
  );
};

// ---------------------------- STYLES ----------------------------

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
    color: "#333399",
    fontWeight: 700,
    padding: "15px 20px",
    fontSize: theme.typography.pxToRem(12),
    borderRadius: "10px",
    fontFamily: "Lato"
  }
}));
